import React, { useEffect, useState, useCallback } from "react";
import { TrashIcon } from "@heroicons/react/20/solid";
import {
  Backdrop,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogTitle,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  ThemeProvider,
  createTheme,
  FormControl,
  InputAdornment,
  OutlinedInput,
  TableContainer,
  Paper,
} from "@mui/material";
import { AddNewGuest } from "./AddNewGuest";
import { ServiceApi } from "../../services/index.service";
import { useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import ClearIcon from "@mui/icons-material/Clear";
import { Pagination, PaginationItem, TablePagination } from '@mui/material';

const rootElement = document.getElementById("root");
const theme = createTheme({
  components: {
    MuiDialog: {
      defaultProps: {
        container: rootElement,
      },
    },
  },
});

export const GuestManagement = () => {
  const pageInitialParams = {
    search: "",
    page: 1,
    size: 15
  }
  const [openNewGuestDialog, setOpenNewGuestDialog] = React.useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const serviceapi = new ServiceApi();
  const [loading, setLoading] = useState(false);
  const { storage } = useSelector((state) => state);
  const [guestList, setGuestList] = useState([]);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [guest, setGuest] = useState("");
  const [guestSearch, setGuestSearch] = useState("");
  const [params, setParams] = useState(pageInitialParams);
  const [totalItems, setTotalItems] = useState('')

  useEffect(() => {
    if (storage?.store?.intStoreID) {
      getAllGuests(params);
    }
  }, [params]);

  useEffect(() => {
    if (storage?.store?.intStoreID) {
      setGuestSearch("");
      setParams(pageInitialParams)
    }
  }, [storage?.store?.intStoreID]);

  const getAllGuests = async (params) => {
    try {
      setLoading(true);
      const getResponse = await serviceapi.getAllGuestData(
        storage?.store?.intStoreID, params
      );
      setGuestList(getResponse.data.items);
      setTotalItems(getResponse.data.total_items)
      setLoading(false);
    } catch (e) {
      console.log("e", e);
    }
  };

  const handleManageGuestSearch = (event) => {
    if (event.target.value !== "") {
      setGuestSearch(event.target.value);
      searchDelay(params, event.target.value);
    } else {
      setGuestSearch("");
      setParams({ ...params, search: '', page: pageInitialParams?.page, size: pageInitialParams?.size });
    }
  };

  const clearFilters = () => {
    setGuestSearch("");
    setParams({ ...params, search: '', page: pageInitialParams?.page, size: pageInitialParams?.size });
  };

  const searchDelay = useCallback(
    debounce((params, val) => {
      setParams({ ...params, search: val, page: pageInitialParams?.page, size: pageInitialParams?.size });
    }, 500),
    []
  );

  function debounce(fn, delay) {
    let timer;
    return function () {
      let context = this,
        args = arguments;
      clearTimeout(timer);
      timer = setTimeout(() => {
        fn.apply(context, args);
      }, delay);
    };
  }

  const handlePageChange = (event, value) => {
    setParams({ ...params, page: value });
  };

  const handleConfirmDialog = () => {
    setOpenDialog(!openDialog);
    setGuest("");
  };

  const handleConfirm = () => {
    deleteGuest(guest);
    setGuest("");
  };

  const deleteGuest = async (guest) => {
    try {
      if (guest?.favGuid) {
        setLoading(true);
        const favguid = {
          favguid: guest?.favGuid,
        };
        const deleteResponse = await serviceapi.deleteGuest(favguid);
        setLoading(false);
        if (deleteResponse?.status === 200) {
          enqueueSnackbar("Guest deleted Successfully", {
            anchorOrigin: { vertical: "top", horizontal: "right" },
            variant: "success",
          });
          getAllGuests(params);
        }  
      }
    } catch (e) {
      console.log("e", e);
    }
  };

  const getUpdatedGuests = () => {
    setParams(pageInitialParams)
    // getAllGuests(params);
  }

  if (openNewGuestDialog) {
    return (
      <ThemeProvider theme={theme}>
        <div className="mt-5 rounded relative">
          <AddNewGuest
            open={openNewGuestDialog}
            handleClose={() => setOpenNewGuestDialog(false)}
            fetchUpdatedGuests={getUpdatedGuests}
          />
        </div>
      </ThemeProvider>
    );
  }

  return (
    <>
      <Backdrop
        openDialog
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Dialog
        open={openDialog}
        onClose={handleConfirmDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={"xs"}
      >
        <DialogTitle id="alert-dialog-title">
          {"Are you sure, you want to Delete Guest?"}
        </DialogTitle>
        <DialogActions>
          <Button onClick={handleConfirmDialog}>Cancel</Button>
          <Button
            onClick={() => {
              setOpenDialog(false);
              handleConfirm();
            }}
            autoFocus
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      <ThemeProvider theme={theme}>
        <div className="relative">
            <Button
              variant="contained"
              className="bg-primary shadow-none capitalize md:absolute mb-2 md:-top-[58px] right-0"
              onClick={() => setOpenNewGuestDialog(!openNewGuestDialog)}
            >
              Add New Guest
            </Button>
          <div className="bg-white p-4 rounded">
                <FormControl sx={{ minWidth: 150, marginBottom: '5px' }}>
                  <OutlinedInput
                    autoComplete="off"
                    style={{
                      fontFamily:
                        "Roboto, 'Open Sans', Verdana, sans-serif, FontAwesome",
                    }}
                    className="bg-white text-xs border rounded border-gray-200"
                    sx={{
                      height: 40,
                      paddingRight: 0,
                      width: 215,
                    }}
                    id="outlined-controlled"
                    placeholder="&#xF002; search for guest name"
                    name="mGuestSearch"
                    value={guestSearch}
                    onChange={handleManageGuestSearch}
                    inputProps={{
                      style: {
                        color: "#000",
                        fontSize: "15px",
                      },
                    }}
                    endAdornment={
                      <InputAdornment>
                        <IconButton
                          onClick={clearFilters}
                          sx={{
                            visibility: guestSearch ? "visible" : "hidden",
                          }}
                        >
                          <ClearIcon />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>

            {guestList.length > 0 && (
              <>
                <Paper className="shadow-none">
                  <TableContainer sx={{ maxHeight: 'calc(100vh - 333px)', borderBottom: '2px solid #e2e2e2' }}>
                    <Table stickyHeader aria-label="sticky table">
                      <TableHead className="bg-[#484848]">
                        <TableRow>
                          <TableCell align="center" className="bg-[#484848] text-white border-[1px] py-2">
                            Record
                          </TableCell>
                          <TableCell align="left" className="bg-[#484848] text-white border-[1px] py-2">
                            Name
                          </TableCell>
                          <TableCell align="left" className="bg-[#484848] text-white border-[1px] py-2">
                            Category
                          </TableCell>
                          <TableCell align="left" className="bg-[#484848] text-white border-[1px] py-2">
                            Flavor
                          </TableCell>
                          <TableCell align="left" className="bg-[#484848] text-white border-[1px] py-2">
                            Email
                          </TableCell>
                          <TableCell align="center" className="bg-[#484848] text-white border-[1px] py-2">
                            Actions
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {guestList.map((guest, index) => (
                          <TableRow
                            key={index}
                            sx={{
                              "&:nth-of-type(odd)": { backgroundColor: "#FFF" },
                              "&:nth-of-type(even)": { backgroundColor: "#FFF8F8" }
                            }}
                          >
                            <TableCell align="center" className="border-[1px] py-1.5">
                              {((params.page - 1) * params.size) + (index + 1)}
                            </TableCell>
                            <TableCell align="left" className="border-[1px] py-1.5">
                              {guest.firstName} {guest.lastName}
                            </TableCell>
                            <TableCell align="left" className="border-[1px] py-1.5">
                              {guest.catName}
                            </TableCell>
                            <TableCell align="left" className="border-[1px] py-1.5">
                              {guest.Flavor}
                            </TableCell>
                            <TableCell align="left" className="border-[1px] py-1.5">
                              {/* Masked email Eg: A*******Z@example.com */}
                              {guest.email?.replace(/^(.)(.*)(.@.*)$/, (_, a, b, c) => a + b.replace(/./g, '*') + c)}
                            </TableCell>
                            <TableCell align="center" className="border-[1px] py-1.5">
                              <IconButton
                                onClick={() => {
                                  handleConfirmDialog(guest);
                                  setGuest(guest);
                                }}
                              >
                                <TrashIcon className="h-4 w-4 text-grey-500" />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '10px', background: '#fff', border: '1px solid #e2e2e2' }}>
                    <Pagination showFirstButton showLastButton
                      count={Math.ceil(totalItems / params.size)}
                      page={params.page}
                      onChange={handlePageChange}
                      renderItem={(item) => (
                        <PaginationItem
                          sx={{
                            "&.Mui-selected": {
                              color: '#fff',
                              backgroundColor: "#C12637"
                            },
                          }}
                          component="a"
                          {...item}
                        />
                      )}
                    />
                  </div>
                </Paper>
              </>
            )}
            {guestList.length === 0 && (
              <div
                className=""
                style={{
                  border: "1px solid #ccc",
                  padding: "10px",
                  // margin: "10px",
                  backgroundColor: "#FFF",
                  color: "#000",
                }}
              >
                No Data found for this store
              </div>
            )}
          </div>
        </div>
      </ThemeProvider>
    </>
  );
};
